import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/idea-management/inbox')({
  beforeLoad: async ({ context: { flags } }) => {
    if (!flags.fimFeedbackInboxEnabled) {
      throw notFound();
    }
  },
});
